import React, { useContext, useEffect, useState } from 'react'
import './ProductDisplay.css'
import star_icon from '../Assets/star_icon.png'
import star_dull_icon from '../Assets/star_dull_icon.png'
import { ShopContext } from '../../Context/ShopContext'

const ProductDisplay = (props) => {

    const { product } = props;
    const { addToCart } = useContext(ShopContext);

    const [variants, setVariants] = useState([]);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedSize, setSelectedSize] = useState('');
    const [selectedColor, setSelectedColor] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [addedToCartMsg, setAddedToCartMsg] = useState('');



    useEffect(() => {
        const fetchVariants = async () => {
            const res = await fetch(`/api/variants/${product.id}`);
            const data = await res.json();
            setVariants(data);
        };

        fetchVariants();
    }, [product.id]);

    useEffect(() => {
      let found = null;
    
      // ha mindkettő kiválasztva
      if (selectedColor && selectedSize) {
        found = variants.find(
          v =>
            v.variantAttributes.color === selectedColor &&
            v.variantAttributes.size === selectedSize
        );
      }
    
      // ha csak szín van kiválasztva
      if (!found && selectedColor) {
        found = variants.find(
          v => v.variantAttributes.color === selectedColor
        );
      }
    
      setSelectedVariant(found || null);
    }, [selectedColor, selectedSize, variants]);
    

  return (
   <div className="productdisplay">
    <div className="productdisplay-left">
        
        <div className="productdisplay-img">
          <img
            className="productdisplay-main-img"
            src={selectedVariant?.image || product.image}
            alt=""
          />

        </div>
    </div>
    <div className="productdisplay-right">
        <h1>{product.name}</h1>
        <div className="productdisplay-right-star">
            <img src={star_icon} alt="" />
            <img src={star_icon} alt="" />
            <img src={star_icon} alt="" />
            <img src={star_icon} alt="" />
            <img src={star_dull_icon} alt="" />
            <p>(122)</p>

        </div>
        <div className="productdisplay-right-prices">
            <div className="productdisplay-right-price-new">
                {selectedVariant?.price || product.price} FT
            </div>
        </div>
        <div className="productdisplay-right-desc">
            {product.desc}
        </div>
        <div className="productdisplay-right-variant">
  <h1>Szín:</h1>
  <div className="productdisplay-right-sizes">
    {[...new Set(variants.map(v => v.variantAttributes.color))].map(color => (
      <div
        key={color}
        className={selectedColor === color ? "selected" : ""}
        onClick={() => setSelectedColor(color)}
      >
        {color}
      </div>
    ))}
  </div>

  <h1>Méret:</h1>
  <p>(A méret csak a szín kiválasztása után jelenik meg)</p>
  <div className="productdisplay-right-sizes">
    {[...new Set(variants
      .filter(v => v.variantAttributes.color === selectedColor)
      .map(v => v.variantAttributes.size))].map(size => (
        <div
          key={size}
          className={selectedSize === size ? "selected" : ""}
          onClick={() => setSelectedSize(size)}
        >
          {size}
        </div>
    ))}
  </div>
</div>




<button
  onClick={() => {
    if (selectedVariant) {
      addToCart(selectedVariant.id, quantity);
      setAddedToCartMsg('✅ Sikeresen hozzáadva a kosárhoz!');
      setTimeout(() => setAddedToCartMsg(''), 3000); // 3 másodperc után eltűnik
    } else {
      alert("Kérlek válaszd ki a színt és méretet!");
    }
  }}
  
>
  KOSÁRBA
</button>
{addedToCartMsg && (
  <p style={{ color: 'green', marginTop: '10px' }}>{addedToCartMsg}</p>
)}



    </div>
   </div>
  )
}

export default ProductDisplay